/** Enum of toast variants, i.e. success, loading or error */
export enum ToastVariant {
    LOADING = 'loading',
    SUCCESS = 'success',
    ERROR = 'error',
}

/** Model used in the state of "toasts" */
export interface ToastOption {
    id: string
    message: string
    variant?: ToastVariant
    actionText?: string
    onRemove?: (id: string) => void
    onAction?: () => void
}
